import { theme as baseTheme } from '../aidu/index.js';
export const colors = {
  ...baseTheme.colors,
  contentBrand: '#2771D4',
  interactionSuccess: '#71B800',
  interactionSuccessHover: '#579A00',
  interactionSuccessPressed: '#488306',
  interactionPrimary: '#FF991D',
  interactionPrimaryHover: '#F88802',
  interactionPrimaryPressed: '#F06E20',
  interactionSecondary: '#649AE2',
  interactionSecondaryHover: '#5A8BCB',
  interactionSecondaryPressed: '#507BB5',
  interactionDanger: '#EC5555',
  interactionDangerHover: '#D33C3C',
  interactionDangerPressed: '#C53939',
  backgroundBrand: '#2771D4',
  backgroundBrandDark: '#003EA1',
  backgroundInteractionSecondaryTransparentDark: 'rgba(39, 113, 212, 0.8)',
  backgroundInteractionSecondaryTransparentLight: 'rgba(39, 113, 212, 0.3)',
  backgroundStateSelectedTransparent: 'rgba(39, 113, 212, 0.1)',
  backgroundStateSelected: '#E9F1FB',
  borderSelection: '#2771D4',
  systemError: '#EC5555',
  systemErrorAlert: '#C53939',
  systemErrorBackground: '#FEF6F6',
  systemErrorHover: '#D33C3C',
  systemErrorBackgroundHover: '#FCE6E6',
  systemErrorBackgroundPressed: '#FFA1A1',
  systemPositive: '#71B800',
  systemPositiveHover: '#579A00',
  systemPositiveAlert: '#488306',
  systemPositiveBackground: '#F7FAF2',
  systemPositiveBackgroundHover: '#E8F2D9',
  systemPositiveBackgroundPressed: '#C6E399',
  brandA: '#2771D4'
};